// Copyright (c) 2024 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import { valueAsKm } from 'helpers/unitConversion'

const formatSegmentEndAux = (site) => {
  const areaOfOperation = site.areaOfOperation
  const certifiedFlag13Ghz = site.certifiedFlag13Ghz
  const radiusKm = valueAsKm(site.radiusKm, site.radiusKmUnit)
  const segmentEndId = castToFloat(site.segmentEndId)

  return {
    areaOfOperation,
    certifiedFlag13Ghz,
    radiusKm,
    segmentEndId,
  }
}

export default formatSegmentEndAux
